import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import Title from "../common/Title"
import Description from "../common/Description"
import AddLineDetails from "./AddLineDetails"
import EmailOTPVerify from "./EmailOTPVerify"
import { verifyEmail } from "../../BackendServices/registrationAPI"
const win = window;

class AddLine extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isFirstStep: true,
            isEmailStep: false,
            hashCode: "",
            loading: false
        }
    }

    componentDidMount(){
        // Verification Started Event
        win.MixpanelTracker.trackEvent("Verification Started");
    }

    goToNextStep = (isFirstStep) => {
        this.setState({
            isFirstStep: isFirstStep
        })
    }

    goToEmailOTP = async (isEmailStep) => {
        const { userName } = this.props;
        this.setState({
            loading: true
        })
        const result = await verifyEmail(userName);
        this.setState({
            isEmailStep: isEmailStep,
            isFirstStep: false,
            hashCode: result.hashCode,
            loading: false
        })
    }

    updateCode = (value) => {
        this.setState({
            hashCode: value
        });
    }

    handleBack = () => {
        this.setState({
            isFirstStep: true,
            isEmailStep: false,
        })
    }

    render() {
        const { t } = this.props;

        return (
            <>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}
                {this.state.isFirstStep &&
                    <section className="addLine-section">
                        <div className="loginIntroTextContainer">
                            <Title title={"acc_created"} />
                            <Title title={"now_add_ur_line"} />
                            <Description description={"add_line_desc"} />
                            <div className="add_line_desc_class">{t("you_can_change")}</div>
                        </div>
                        <div className="tabs">
                            <div className="tab-content">
                                <button type="button" id={"addFirstLine-button"} className="btn min_outlin_btn active" onClick={() => this.goToNextStep(false)}>
                                    {t("add_line_btn")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                </button>
                                {!this.props.isThirdParty && <button type="button" id={"skipNow-button"} className="btn_skip" onClick={() => this.goToEmailOTP(true)}>
                                    {t("skip_btn")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                </button>}

                            </div>
                        </div>
                    </section>}
                {!this.state.isFirstStep && !this.state.isEmailStep && (
                    <AddLineDetails
                        redirectURL={this.props.redirectURL}
                        transactionId={this.props.transactionId}
                        clientInfo={this.props.clientInfo}
                        clientId={this.props.clientId}
                        handleBack={this.handleBack}
                    />
                )}
                {this.state.isEmailStep && !this.state.isFirstStep && (
                    <EmailOTPVerify
                        redirectURL={this.props.redirectURL}
                        msisdn={''}
                        transactionId={''}
                        apFirstName={""}
                        apLastName={""}
                        companyName={""}
                        userEmail={this.props.userEmail}
                        hashCode={this.state.hashCode}
                        userName={this.props.userName}
                        updateCode={this.updateCode}
                        handleBack={this.handleBack}
                    />
                )}
            </>
        )
    }
}
export default withTranslation()(AddLine);
